import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-900/30">
      <div className="text-center mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-white font-heading">影视分类</h2>
        <p className="text-sm text-foreground-400 mt-1">按类型浏览，快速找到你想看的内容</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-900/80 hover:bg-background-800/80 border border-background-700/30 hover:border-primary-500/30 transition-all duration-300"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors duration-300">
              <i className={`${cat.icon} text-xl md:text-2xl text-primary-400`}></i>
            </div>
            <div className="text-center">
              <h3 className="text-sm font-semibold text-white group-hover:text-primary-400 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 hidden sm:block">{cat.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}